<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统 
                </el-breadcrumb-item>
				<el-breadcrumb-item>规则管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.belongTo" placeholder="请选择适用对象">
						<el-option key="" label="请选择适用对象" value=""></el-option>
						<el-option key="0" label="QQ" value="0"></el-option>
						<el-option key="1" label="微信" value="1"></el-option>
					</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="规则名称"></el-table-column>
				<el-table-column prop="regularType" label="数据类型" :formatter="regularTypeFormat"></el-table-column>
				<el-table-column prop="replay" label="是否有交互">
					<template slot-scope="scope">
						{{scope.row.replay?"是":"否"}}
                    </template>
				</el-table-column>
				<el-table-column prop="belongTo" label="适用于" :formatter="belongToFormat"></el-table-column>
				<el-table-column prop="latestCollectTime" label="最新采集时间"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="规则名称" prop="name">
					<el-input v-model="form.name" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="数据类型" prop="regularType">
					<el-select v-model="form.regularType" placeholder="请选择数据类型">
						<el-option key="" label="请选数据类型" value=""></el-option>
						<el-option v-for="item in regularTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否有交互" prop="replay">
					<el-select v-model="form.replay" placeholder="请选择是否有交互">
						<el-option key="" label="请选择是否有交互" value=""></el-option>
						<el-option :key="false" label="没有交互" :value="false"></el-option>
						<el-option :key="true" label="有交互" :value="true"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="适用于" prop="belongTo">
					<el-select v-model="form.belongTo" placeholder="请选择适用对象">
						<el-option key="" label="请选择适用对象" value=""></el-option>
						<el-option :key="0" label="QQ" :value="0"></el-option>
						<el-option :key="1" label="微信" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="棋手规则" prop="playerRegular">
					<el-input type=textarea :rows=5 v-model="form.playerRegular"> </el-input>
				</el-form-item>
				<el-form-item label="产品规则" prop="productRegular">
					<el-input type=textarea :rows=5 v-model="form.productRegular"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchChessRegularData, saveChessRegular, getChessRegular, deleteChessRegular} from '../../../api/index';
export default {
    name: 'chess-regular',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
			title:"",
			isDisabled:false,
			rules: {
                name: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
				regularType: [{ required: true, message: '请选择数据类型', trigger: 'blur' }],
				replay: [{ required: true, message: '请选择是否有交互', trigger: 'blur' }],
				belongTo: [{ required: true, message: '请选择适用对象', trigger: 'blur' }],
				playerRegular: [{ required: true, message: '棋手规则不能为空', trigger: 'blur' }],
				productRegular: [{ required: true, message: '产品规则不能为空', trigger: 'blur' }]
            },
			productOptions:[],
			regularTypeKV:[{"key":0,"value":"渠道"},{"key":1,"value":"客户"},{"key":2,"value":"客渠混合"}],
			belongToKV:{"0":"QQ","1":"微信"},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("chess-regular");
        this.getData();
    },
    methods: {
		belongToFormat(row, column, cellValue) {
			return this.belongToKV[cellValue];
		},
		//类型匹配
		regularTypeFormat(row, column, cellValue) {
			let regularConfig = {"0":"渠道", "1":"客户", "2":"客渠混合"};
			return regularConfig[cellValue];
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChessRegularData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChessRegular([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
		handleEdit(index, row) {
			this.form = {};
			this.title = "编辑";
			getChessRegular(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取规则信息失败！` + res.message);
				}
			})
			
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveChessRegular(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
